import styled from '../../../styles/styledComponents/themeComponents';

export const SearchBoxStyle = styled.div`
  padding: 15px 30px;
  background-color: #fff;
  border: 1px solid #e7eaec;

  & > .amondz-form:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e7eaec;
  }

  .btn-area {
    text-align: center;

    button {
      width: 150px;
    }

    button + button {
      margin-left: 10px;
    }
  }

  .amondz-form {
    display: flex;
    align-items: center;

    .content {
      padding-left: 50px;
    }
  }
`;
